import { useEffect } from "react";
import {
  SetProductCatFeatureAtom,
  GetProductCatFeatureAtom,
} from "../../store/productCategoryFeatureAtom";
import { useNavigate, useLocation } from "react-router-dom";

import Tooltip from "@mui/material/Tooltip";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { settingsService } from "../../services/settingsService";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { formatCustomDate } from "../../helpers/formatCustomDate";
import { FaAdn } from "react-icons/fa";

const columns = [
  {
    title: "Product Name",
    key: "Product_Name",
    dataIndex: "Product_Name",
    sorter: (a, b) =>
      (a?.Product_Name ?? "").localeCompare(b?.Product_Name ?? ""),
  },
  {
    title: "Web URL",
    key: "Action_URL_Web",
    dataIndex: "Action_URL_Web",
    className: "text-primary",
    sorter: (a, b) =>
      (a?.Action_URL_Web ?? "").localeCompare(b?.Action_URL_Web ?? ""),
  },
  {
    title: "Mobile URL",
    key: "Action_URL_Mobile",
    dataIndex: "Action_URL_Mobile",
    className: "text-primary",
    sorter: (a, b) =>
      (a?.Action_URL_Mobile ?? "").localeCompare(b?.Action_URL_Mobile ?? ""),
  },
  {
    title: "Description",
    dataIndex: "Product_Description",
  },
  {
    title: "Display Order",
    dataIndex: "Display_Order",
    sorter: (a, b) => (a?.Display_Order ?? 0) - (b?.Display_Order ?? 0),
  },
  {
    title: "Created",
    dataIndex: "Encoded_Date",
    sorter: (a, b) =>
      (a?.Encoded_Date ?? "").localeCompare(b?.Encoded_Date ?? ""),
    render: (date) => <span>{formatCustomDate(date)}</span>,
  },
];

function ProductFeaturePage() {
  const getFeatureList = GetProductCatFeatureAtom();
  const setFeatureList = SetProductCatFeatureAtom();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [moduleId, moduleName, userMenu] = pathname.split("/").slice(1, 4);

  useEffect(() => {
    if (!getFeatureList?.action_url_info?.length) {
      fetchDataFromServer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchDataFromServer = () => {
    settingsService.getProductFeatureList().then((res) => {
      if (res.data?.action_url_info?.length) {
        setFeatureList(res.data);
      }
    });
  };

  const newFeatureSetup = () => {
    navigate(`/${moduleId}/${moduleName}/${userMenu}/add-new`);
  };

  const handleRowClick = (record) => {
    navigate(
      `/${moduleId}/${moduleName}/${userMenu}/details/${record?.Product_Id}`
    );
  };


  return (
    <div className=" bg-white">
      <div className="flex justify-between items-center mb-4">
        <Tooltip title="Reload">
          <button
            onClick={fetchDataFromServer}
            className="text-blue-600 hover:text-blue-800 transition-colors p-1.5 rounded-full bg-gray-200 hover:bg-gray-100 active:rotate-12 active:bg-gray-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="size-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
              />
            </svg>

            {/* <RestartAltIcon fontSize="medium" /> */}
          </button>
        </Tooltip>

        <Tooltip title="Add New">
          <button
            onClick={newFeatureSetup}
            className="bg-blue-600 hover:bg-blue-700 flex flex-row items-center text-sm font-medium px-3 py-2 rounded-md transition-colors"
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-4 text-white"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 4.5v15m7.5-7.5h-15"
                />
              </svg>
            </span>{" "}
            <span className="ml-1 text-white"> Add New</span>
          </button>
        </Tooltip>
      </div>
    <section className="mt-5" >
    <GeneralCustomTable
        tableHeadList={columns}
        tableDataList={getFeatureList?.product_feature_info || []}
        allowCheckBox={false}
        rowKey={(record) => record.Ref_No}
        handleRowClick={handleRowClick}
      />
    </section>
  
    </div>
  );
}

export default ProductFeaturePage;
